export interface StudentPerformanceMetric {
  id: number;
  group_performance_metric_id: number;
  performance_metric_id: number;
  student_id: number;
  note: string;
  period_id: number;
}
